export default __webpack_public_path__ + "static/media/david4.e1461b8a.jpg";